import React, { FunctionComponent } from 'react'
import { PostMatchProps } from '../MatchTypes'
import Template from '../Template'
import ButtonFont from '../../../Theme/Fonts/Button'
import LabelFont from '../../../Theme/Fonts/Label'

export const veryThinSpace = String.fromCodePoint(0x200a)
const PostMatch: FunctionComponent<Omit<PostMatchProps, 'type'>> = ({
    additionalField1,
    additionalField2,
    awayCompetitor,
    awayScore,
    caption,
    homeCompetitor,
    homeScore,
    minify,
    onPressMatch,
    matchHref,
    onPressMore,
    testID,
    winner,
    isSingleMatch,
    centerComponentWidth,
    betProps,
    paddingTop,
    borderRadius,
    forceMobileView,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText = 'Re-Live',
}) => {
    return (
        <Template
            additionalField1={additionalField1}
            additionalField2={additionalField2}
            awayCompetitor={{
                ...awayCompetitor,
                isBold: winner === 'AWAY',
            }}
            center={
                caption ? (
                    <LabelFont>{caption}</LabelFont>
                ) : (
                    <ButtonFont
                        color="onyx"
                        fontSize="FS16"
                        lineHeight="LH20"
                    >{`${homeScore}${veryThinSpace}:${veryThinSpace}${awayScore}`}</ButtonFont>
                )
            }
            homeCompetitor={{
                ...homeCompetitor,
                isBold: winner === 'HOME',
            }}
            centerComponentWidth={centerComponentWidth}
            minify={minify}
            isSingleMatch={isSingleMatch}
            onPressMatch={onPressMatch}
            onPressVideoButton={onPressVideoButton}
            videoButtonHref={videoButtonHref}
            videoButtonText={videoButtonText}
            matchHref={matchHref}
            onPressMore={onPressMore}
            testID={testID}
            betProps={betProps}
            paddingTop={paddingTop}
            borderRadius={borderRadius}
            forceMobileView={forceMobileView}
        />
    )
}

export default PostMatch
